import React, { useEffect, useRef,useState } from 'react';

import styles from './PhonePreview.module.scss';

export default function PhonePreview({
  image,
  title,
  description,
  businessName,
  city,
  discountValue,
  showCTA = true,
  logo,
  coupon,
}) {
  const [animateKey, setAnimateKey] = useState(0);
  const firstRender = useRef(true);

  useEffect(() => {
    if (firstRender.current) {
      firstRender.current = false;
      return;
    }
    setAnimateKey(prev => prev + 1);
  }, [image]);

  return (
    <div className={styles.phoneFrame}>
      {/* INNER SCREEN */}
      <div
        className={`${styles.phoneScreen} ${styles.fadeIn}`}
        key={animateKey}
      >
        {/* HEADER */}
        <div className={styles.header}>
          <button className={styles.backBtn}>←</button>
          <span className={styles.headerTitle}>Coupon Details</span>
        </div>

        {/* CONTENT + SCROLL */}
        <div className={styles.scrollShell}>
          <div className={styles.scrollArea}>
            {/* HERO IMAGE NOW SCROLLS WITH CONTENT */}
            <div className={styles.heroBox}>
              {image ? (
                <img src={image} alt="coupon" className={styles.heroImg} />
              ) : (
                <div className={styles.heroPlaceholder}>Add an image</div>
              )}
            </div>

            <div className={styles.content}>
              <div className={styles.businessRow}>
                <div className={styles.avatar}>
                  {logo ? (
                    <img
                      src={logo}
                      className={styles.logoImg}
                      alt={businessName || 'Business logo'}
                    />
                  ) : (
                    <span>
                      {businessName
                        ? businessName.charAt(0).toUpperCase()
                        : 'B'}
                    </span>
                  )}
                </div>

                <div className={styles.businessName}>{businessName}</div>
              </div>

              {/* DEAL VALUE ABOVE TITLE */}
              {discountValue && (
                <div className={styles.dealValueRow}>
                  <span className={styles.dealValueLabel}>Deal Value</span>
                  <span className={styles.dealValueAmount}>
                    {discountValue}
                  </span>
                </div>
              )}

              <h3 className={styles.title}>{title || 'Your Coupon Title'}</h3>

              <p className={styles.description}>
                {description ||
                  'This is where your coupon details will appear.'}
              </p>

              {/* If you still want the old pill badge, keep this.
                  Otherwise you can delete it safely. */}
              {/* {discountValue && (
                <div className={styles.discountBox}>{discountValue}</div>
              )} */}
            </div>
          </div>

          {/* STATIC TOP/BOTTOM SHADOWS (NOT SCROLLING) */}
          <div className={styles.shadowTop} />
          <div className={styles.shadowBottom} />
        </div>

        {/* CTA BUTTON */}
        {showCTA && (
          <div className={styles.ctaWrapper}>
            <button className={styles.ctaBtn}>Redeem Now</button>
          </div>
        )}
      </div>
    </div>
  );
}
